import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SupplementaryEquipmentDetailsComponent } from './component/supplementary-equipment-details.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule } from '@angular/forms';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';
import { MaterialModule } from '@sdbn/appclient';

@NgModule({
  declarations: [
    SupplementaryEquipmentDetailsComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ApplicationClientCommonModule,
    CommonTranslationModule
  ]
})
export class SupplementaryEquipmentDetailsModule { }
